import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';
import { PortalService } from 'src/services/portal.service';

@Component({
    selector: 'painel-SRAG-component',
    templateUrl: 'painel-SRAG-component.html',
    styleUrls: ['painel-SRAG-component.scss'],
})

export class PainelSRAGComponent implements OnInit {

    listEtiologia: any[] = [];
    listFaixa: any[] = [];
    listSrag: any[] = [];
    listCovid: any[] = [];

    datasetsEtiologia: any;
    datasetsFaixaEtaria: any;
    datasetsSRAGCOVID: any;
    datasets20192010: any;

    constructor(private portal: PortalService) {
    }

    async ngOnInit() {
        console.log('ngOnInit -> PainelSRAGComponent');
        this.loadEtiologia();
        this.loadFaixa();
        this.loadSrag();
        this.loadCovid();
    }

    async loadEtiologia() {
        this.listEtiologia = await this.portal.getCDN('PortalEtiologia');

        this.datasetsEtiologia = {
            labels: _.map(this.listEtiologia, 'label'),
            datasets: [
                {
                    label: 'SARS COV2',
                    backgroundColor: '#5D78FF',
                    data: _.map(this.listEtiologia, 'qtd_sars_cov2'),
                    datalabels: {
                        display: false,
                    },
                },
                {
                    label: 'Investigação',
                    backgroundColor: '#FAB822',
                    datalabels: {
                        display: false,
                    },
                    data: _.map(this.listEtiologia, 'qtd_investigacao'),
                },

                {
                    label: ' Influenza A e B',
                    backgroundColor: '#1FBB87',
                    datalabels: {
                        display: false,
                    },
                    data: _.map(this.listEtiologia, 'qtd_influenza_ab'),
                },
                // {
                //     label: 'Influenza A (H1N1)',
                //     backgroundColor: '#FAB822',
                //     datalabels: {
                //         display: false,
                //     },
                //     data: _.map(this.listEtiologia, 'qtd_influenza_a'),
                // },
                {
                    label: 'Outros',
                    datalabels: {
                        display: false,
                    },
                    backgroundColor: '#DAE9F7',
                    data: _.map(this.listEtiologia, 'qtd_outros'),
                },

            ],
        };
    }

    async loadFaixa() {
        this.listFaixa = await this.portal.getCDN('PortalFaixa');

        this.datasetsFaixaEtaria = {
            labels: _.map(this.listFaixa, 'label'),
            datasets: [
                {
                    label: 'Homens',
                    backgroundColor: '#5D78FF',
                    datalabels: {
                        display: false,
                    },
                    data: _.map(this.listFaixa, 'qtd_mulheres'),
                },
                {
                    label: 'Mulheres',
                    datalabels: {
                        display: false,
                    },
                    backgroundColor: '#FAB822',
                    data: _.map(this.listFaixa, 'qtd_homens'),
                }
            ],
        };

    }

    async loadSrag() {
        this.listSrag = await this.portal.getCDN('PortalSrag');

        this.datasets20192010 = {
            labels: _.map(this.listSrag, 'label'),
            datasets: [
                {
                    label: '2019',
                    backgroundColor: '#FAB822',
                    datalabels: {
                        display: false,
                    },
                    data: _.map(this.listSrag, 'qtd_2019'),
                },
                {
                    label: '2020',
                    datalabels: {
                        display: false,
                    },
                    backgroundColor: '#FB397A',
                    data: _.map(this.listSrag, 'qtd_2020'),
                }
            ],
        };
    }

    async loadCovid() {
        this.listCovid = await this.portal.getCDN('PortalCovid');

        this.datasetsSRAGCOVID = {
            labels: _.map(this.listCovid, 'label'),
            datasets: [
                {
                    label: 'Covid-19',
                    backgroundColor: '#FAB822',
                    datalabels: {
                        display: false,
                    },
                    data: _.map(this.listCovid, 'qtd_covid'),
                },
                {
                    label: 'Demais Casos',
                    datalabels: {
                        display: false,
                    },
                    backgroundColor: '#1FBB87',
                    data: _.map(this.listCovid, 'qtd_outros'),
                }
            ],
        };
    }
}
